import * as config from '../../../static/config/form.js';

export default {
  namespaced: true,
  state: {
    alive: true,
    sliderDragEvent: false,
    resultJson: {...config.form.resultJson},
    dataToSave: {},
    orderedLayouts: [...config.form.orderedLayouts],
    currentLayout: config.form.currentLayout,
    authorizedStep: {...config.form.authorizedStep}
  },

  getters: {
    isNextLayout: state => {
      return state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) + 1] !== undefined && state.authorizedStep[state.currentLayout];
    },
    currentIndexStep: state => {
      return state.orderedLayouts.indexOf(state.currentLayout) + 1;
    }
  },

  mutations: {
    FORM_SETLAYOUT: (state, index) => {
      if (state.orderedLayouts[index - 1] === undefined || state.authorizedStep[state.orderedLayouts[index - 1]]) {
        state.currentLayout = state.orderedLayouts[index];
      }
    },
    FORM_PREVIOUSLAYOUT: (state) => {
      if (state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) - 1] !== 'null') {
        state.currentLayout = state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) - 1];
      } else {
        state.currentLayout = state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) - 2];
      }
    },
    FORM_NEXTLAYOUT: (state) => {
      if (!state.currentLayout) {
        state.currentLayout = state.orderedLayouts[0];
      } else {
        let nextIndex = state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) + 1];
        if (state.currentLayout === 'Target') {
          if (typeof state.authorizedStep[state.resultJson.target.component] !== 'undefined') {
            state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) + 1] = state.resultJson.target.component;
            nextIndex = state.resultJson.target.component;
          } else if (typeof state.authorizedStep[state.resultJson.target.component] === 'undefined') {
            state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) + 1] = 'null';
            nextIndex = state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) + 2];
            state.authorizedStep[state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout)]] = true;
          }
        }
        state.currentLayout = (nextIndex) || state.currentLayout;
      }
      state.authorizedStep[state.orderedLayouts[state.orderedLayouts.indexOf(state.currentLayout) - 1]] = true;
      if (!state.authorizedStep[state.currentLayout]) {
        state.authorizedStep[state.currentLayout] = false;
      }
    },
    FORM_SAVEDATA: (state, data) => {
      if (data !== undefined) {
        Object.keys(data).forEach((key) => {
          state.resultJson[key] = data[key];
        });
      }
    },
    FORM_AUTHORIZENEXTSTEP: (state, {layout, isAuthorized, data}) => {
      state.authorizedStep[layout] = isAuthorized;
      if (!isAuthorized) {
        for (var i = state.orderedLayouts.indexOf(layout); i < state.orderedLayouts.length; i++) {
          state.authorizedStep[state.orderedLayouts[i]] = isAuthorized;
        }
      } else {
        state.authorizedStep[layout] = isAuthorized;
      }
      state.dataToSave = data;
    },
    FORM_RESET: (state) => {
      if (state.resultJson.userInfos.lastname !== '' && state.resultJson.userInfos.firstname !== '') {
        let currentDate = new Date();
        let fileName = currentDate.getFullYear().toString() + '-' + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate()) + '-' + (currentDate.getHours()) + '-' + (currentDate.getMinutes()) + '-' + (currentDate.getSeconds());
        fileName += '-' + state.resultJson.userInfos.lastname + '-' + state.resultJson.userInfos.firstname + '.json';
        localStorage.setItem(fileName, JSON.stringify(state.resultJson, undefined, 2));
      }
      state.alive = false;
    },
    FORM_ENABLEFORM: (state) => {
      state.alive = true;
      let previousAdvisor = state.resultJson.advisor;
      state.resultJson = {...config.form.resultJson};
      state.resultJson.advisor = previousAdvisor;
      state.dataToSave = {};
      state.orderedLayouts = [...config.form.orderedLayouts];
      state.currentLayout = config.form.currentLayout;
      state.authorizedStep = {...config.form.authorizedStep};
    },
    FORM_CHANGEADVISOR: (state, data) => {
      state.resultJson.advisor = data;
    },
    SLIDER_DRAG_EVENT: (state, event) => {
      state.sliderDragEvent = event;
    }
  },

  actions: {
    FORM_SETLAYOUT: (context, {index, data}) => {
      context.commit('FORM_SAVEDATA', data);
      context.commit('FORM_SETLAYOUT', index);
    },
    FORM_PREVIOUSLAYOUT: (context) => {
      context.commit('FORM_PREVIOUSLAYOUT');
    },
    FORM_NEXTLAYOUT: (context, data) => {
      context.commit('FORM_SAVEDATA', data);
      context.commit('FORM_NEXTLAYOUT');
    },
    FORM_AUTHORIZENEXTSTEP: (context, {layout, isAuthorized, data}) => {
      context.commit('FORM_AUTHORIZENEXTSTEP', {layout, isAuthorized, data});
    },
    FORM_RESET: (context) => {
      context.commit('FORM_RESET');
    },
    FORM_ENABLEFORM: (context) => {
      context.commit('FORM_ENABLEFORM');
    },
    FORM_CHANGEADVISOR: (context, data) => {
      context.commit('FORM_CHANGEADVISOR', data);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/form.js